import { useState } from 'react'
import Swal from 'sweetalert2'
import { useTranslation } from 'react-i18next'
import ExpensesService from '@/services/ExpensesService'

export function useExpenseActions(loadExpensesData) {
	const { t } = useTranslation()
	const [isDeleting, setIsDeleting] = useState(false)

	const handleDeleteSelected = async (selectedExpenses, clearSelection) => {
		if (!selectedExpenses.size) {
			Swal.fire({
				title: t('expenses.list.deleteDialog.noneSelectedTitle'),
				text: t('expenses.list.deleteDialog.noneSelectedText'),
				icon: 'warning'
			})
			return
		}

		const result = await Swal.fire({
			title: t('expenses.list.deleteDialog.confirmTitle'),
			text: t('expenses.list.deleteDialog.confirmText', { count: selectedExpenses.size }),
			icon: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#d33',
			cancelButtonColor: '#3085d6',
			confirmButtonText: t('expenses.list.deleteDialog.confirmButton'),
			cancelButtonText: t('expenses.list.deleteDialog.cancelButton'),
		})

		if (!result.isConfirmed) return

		setIsDeleting(true)
		try {
			const ids = Array.from(selectedExpenses)
			const response = await ExpensesService.deleteExpenses(ids)
			if (!response.success) {
				throw new Error(response.error || t('expenses.list.deleteDialog.errorFallback'))
			}

			Swal.fire({
				title: t('expenses.list.deleteDialog.deletedTitle'),
				text: response.message || t('expenses.list.deleteDialog.deletedSuccess'),
				icon: 'success'
			})
			clearSelection()
			loadExpensesData()
		} catch (error) {
			console.error('Delete expenses error:', error)
			Swal.fire({
				title: t('expenses.list.deleteDialog.errorTitle'),
				text: error.message || t('expenses.list.deleteDialog.unexpectedError'),
				icon: 'error'
			})
		} finally {
			setIsDeleting(false)
		}
	}

	return {
		isDeleting,
		handleDeleteSelected,
	}
}
